import { useDiscover } from '../hooks/useDiscover'

export default function AssessmentPreview() {
  const { assessmentPreviewModalOpen } = useDiscover()

  if (!assessmentPreviewModalOpen) return null

  return (
    <div className='pointer-events-none fixed z-20 flex h-screen w-full items-center justify-center'>
      <div className='mobile-phone -translate-x-[120px]'>
        <div className='mobile-phone-brove'>
          <span className='mobile-phone-speaker' />
        </div>
        <div className='mobile-phone-screen bg-paleGrey'>
          <img
            className='w-full object-contain'
            src={
              'https://aivy-assets.s3.eu-central-1.amazonaws.com/challenges/tower-of-london/instruction.gif'
            }
            alt='Assessment Vorschau'
          />
        </div>
      </div>
    </div>
  )
}
